import createSourceDataHook from './createSourceDataHook';
import {
    formatAddedOn,
    tikTokHealthStatKeys as ungroupedHealthStatKeys,
} from './sourceDataShaping';
import { getTikTokAndSearchHealthStats } from 'state/utils';
import { getTikTokWatchlistHashtagData } from '../api/tiktok.api';

const shapeHashtagRow = (item) => {
    const healthStats = getTikTokAndSearchHealthStats({
        healthStatKeys: ungroupedHealthStatKeys,
        tikTokDataPoint: item,
    });

    return {
        ...item,
        name: item?.hashtag_name,
        healthStats,
        cluster: item.cluster ? `tiktok ${item.cluster}` : item.cluster,
        addedOn: formatAddedOn(item.added_on),
        ...(item.brand_name
            ? {
                  searchField:
                      `${item?.hashtag_name || ''} ${item.brand_name}`.trim(),
              }
            : {}),
        type: 'hashtag',
        fetching: false,
        fetchingData: false,
    };
};

const queryFn = async ({ queryKey }) => {
    const resp = await getTikTokWatchlistHashtagData({
        data: {
            ...queryKey[1],
            week: queryKey[1].week
                ? queryKey[1].week === '*'
                    ? '*'
                    : [queryKey[1].week]
                : null,
            year: queryKey[1].year
                ? queryKey[1].year === '*'
                    ? '*'
                    : [queryKey[1].year]
                : null,
        },
    });

    return {
        ...resp,
        data: resp.data?.map(shapeHashtagRow),
    };
};

const useTikTokWatchlistHashtagData = createSourceDataHook({
    queryName: 'TikTokWatchlistHashtagData',
    queryFn,
});

export default useTikTokWatchlistHashtagData;
